<template>
  <div>
    <div
      class="z-100 bg-sidebar text-sidebar-foreground lg:absolute lg:top-0 lg:left-0 lg:h-screen lg:flex lg:flex-col lg:transition-[width] lg:duration-200 lg:ease-in-out"
      :class="collapsed ? 'lg:w-14' : 'lg:w-65'"
    >
      <nav class="lg:flex-1 lg:min-h-0 lg:flex lg:flex-col w-full shrink-0">
        <!-- Header: branding + header actions -->
        <div
          class="h-14 w-full bg-sidebar flex justify-between items-center px-3 border-sidebar-border shrink-0"
          :class="collapsed ? 'lg:px-0 lg:justify-center' : ''"
        >
          <slot name="brand" :collapsed="collapsed" />
          <slot name="header-actions" :collapsed="collapsed" />
        </div>

        <!-- Scrollable nav body (responsive mobile collapse) -->
        <div
          :class="mobileOpen ? 'scale-y-100 translate-y-0' : 'scale-y-0 -translate-y-1/2 lg:scale-y-100 lg:translate-y-0'"
          class="scroll-container overflow-y-auto bg-sidebar w-full transform transition-all duration-200 rounded-b-xl lg:rounded-b-none pb-1 lg:pb-0 lg:relative lg:transform-none lg:transition-none lg:flex-1 lg:min-h-0 z-30"
        >
          <div class="lg:h-full h-64 lg:pt-2 lg:space-y-0.5" :class="mobileOpen ? '' : 'lg:block hidden '">
            <slot :collapsed="collapsed" />
          </div>
        </div>

        <!-- Footer (e.g. account menu) -->
        <div v-if="$slots.footer" class="hidden lg:block border-t border-sidebar-border p-2 shrink-0">
          <slot name="footer" :collapsed="collapsed" />
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarShell',
  props: {
    // Desktop icon-only collapsed state.
    collapsed: { type: Boolean, default: false },
    // Mobile expanded state for the nav body.
    mobileOpen: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.scroll-container::-webkit-scrollbar {
  width: 1px;
}

.scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.scroll-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}

.scroll-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.5) transparent;
}
</style>
